import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { RegisterPage } from './pages/RegisterPage';
import { LookupPage } from './pages/LookupPage';
import { StartListsPage } from './pages/StartListsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AdminLayout } from './admin/AdminLayout';
import { CallbackPage } from './admin/CallbackPage';
import { DashboardPage } from './admin/DashboardPage';
import { EntriesPage } from './admin/EntriesPage';
import { HeatsPage } from './admin/HeatsPage';
import { OrganisersPage } from './admin/OrganisersPage';
import { SettingsPage } from './admin/SettingsPage';

export function App() {
  return (
    <Routes>
      {/* Public site */}
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/my-entry" element={<LookupPage />} />
        <Route path="/start-lists" element={<StartListsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* Cognito returns here after sign-in; kept outside the admin shell so it
          renders before any authenticated data is requested. */}
      <Route path="/admin/callback" element={<CallbackPage />} />

      {/* Admin portal. AdminLayout gates everything behind the admins group. */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="entries" element={<EntriesPage />} />
        <Route path="heats" element={<HeatsPage />} />
        <Route path="organisers" element={<OrganisersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}
